import React from 'react';
import cx from 'classnames';
import { node } from 'prop-types';
import style from './MainWrapper.module.scss';
import useDisplayBanner from '../../hooks/useDisplayBanner';

const MainWrapper = ({ children, showVerifyEmailBanner, isOnPublicPath }) => {
  const showTrialBanner = useDisplayBanner();

  return (
    <div
      className={cx(
        style.main,
        !isOnPublicPath && style.hasHeader,
        !isOnPublicPath && showTrialBanner && style.showTrialBanner,
        showVerifyEmailBanner && style.showVerifyEmailBanner,
      )}
    >
      {children}
    </div>
  );
};

MainWrapper.propTypes = {
  children: node.isRequired,
};

export default MainWrapper;
